import styled from 'styled-components';
import { PhotoCard } from '../../ItemCreationForm/AddNewItemForm/components/GalleryItem/styled';

export const PhotoCardPlaceholder = styled(PhotoCard)`
  background-color: ${({ theme }) => theme.colors.background.secondary};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Spinner = styled.span`
  z-index: 2;
  width: 48px;
  height: 48px;
  animation: rotation 2s infinite linear;
  background-image: url('/static/images/icon-spinner.svg');
`;
